import React from "react";
import {connect,} from "~/redux/connect";
import {getResultsValue,} from "~/stateGetter";
import {getFitleredViewState,} from "~/StateGetters/FilteredViewStateGetters";
import {Button, Tooltip,} from "~/native-ui";
import { useResponsiveTextProps, withResponsiveFlags } from '~/hoc/withResponsiveProps';
import {useWindowDimensions} from 'react-native';


const TableRecordsCountAndTitle = withResponsiveFlags(
    ({ trans, recordsCount, title, isXS, ...props }, ref) => {
        const titleWithNumber = isNaN(recordsCount) ? title : trans("table.title_and_count", { count: Number(recordsCount), title });

        const stack = React.useRef({ space: 2 }).current;

        
        const text = useResponsiveTextProps(isXS, 150, 280);

        return (
            <Tooltip tooltip={titleWithNumber}>
                <Button _stack={stack} _text={text} primary variant="outline" rightIcon="arrow-drop-down" iconProps={{ size: "sm" }} {...props}>
                    {titleWithNumber}
                </Button>
            </Tooltip>
        )
    },
    { includeKeys: ["isXS"], debug: true }
);

const mapStateToProps = (state, { modelId, title }) => {
    return {
        recordsCount: getResultsValue(state, modelId)?.total,
        title: getFitleredViewState(state, modelId).getFilteredViewTitle(),
    };
}


export default connect(mapStateToProps)(TableRecordsCountAndTitle);